/**
 * Utility to resolve image URLs properly across environments.
 * Handles:
 * - Full URLs (Cloudinary, external CDN, blob, data URLs)
 * - Local uploads (/uploads/xyz.jpg) prepending backend base URL
 * - Accidental filesystem disk paths (e.g. C:\...\uploads\xyz.jpg or /var/www/.../uploads/xyz.jpg)
 */
export const getImageUrl = (image) => {
  if (!image) return '';
  if (typeof image !== 'string') return '';
  
  const trimmed = image.trim();
  if (!trimmed) return '';

  if (
    trimmed.startsWith('http://') ||
    trimmed.startsWith('https://') ||
    trimmed.startsWith('data:') ||
    trimmed.startsWith('blob:')
  ) {
    return trimmed;
  }

  // Handle Windows or Linux absolute disk path stored accidentally
  let cleanPath = trimmed;
  if (cleanPath.includes('uploads')) {
    const filename = cleanPath.split(/[/\\]/).pop();
    cleanPath = `/uploads/${filename}`;
  } else if (!cleanPath.startsWith('/')) {
    cleanPath = `/${cleanPath}`;
  }

  const backendBase = (process.env.REACT_APP_API_URL || 'http://localhost:5000/api').replace(/\/api\/?$/, '');
  return `${backendBase}${cleanPath}`;
};

export default getImageUrl;

